import {
  NORMAL,
  DISTRESS,
  ACCENT,
  UNAVAILABLE,
  AVAILABLE,
  ERROR,
} from 'app/constants/statusColors'

export const STATUS_ADDED = 0
export const STATUS_INVITED = 1
export const STATUS_PENDING = 2
export const STATUS_SUBSCRIBED_ACCEPT_REQUEST = 3
export const STATUS_SUBSCRIBED_ACCEPT_INVITATION = 4
export const STATUS_SUBSCRIBED_PUBLIC_SUBSCRIBE = 5
export const STATUS_REJECTED_BY_ADMIN = 6
export const STATUS_REJECTED_BY_APP_USER = 7
export const STATUS_UNSUBSCRIBED_REMOVE_SUBSCRIPTION = 8
export const STATUS_UNSUBSCRIBED_UNSUBSCRIBED = 9
export const STATUS_FOLLOW = 10
export const STATUS_UNVERIFIED = 11
export const STATUS_DECLINE_BY_USER = 12

export const SOURCE_APP = 0
export const SOURCE_CSV = 1
export const SOURCE_SIS = 2
export const SOURCE_ONE_BY_ONE = 5
export const SOURCE_WIDGET = 6
export const SOURCE_ISO = 3
export const SOURCE_ANDROID = 4

export const CONTACT_TYPE_VALID_0 = 0
export const CONTACT_TYPE_VALID_1 = 1
export const CONTACT_TYPE_INVALID = 2

export const STATUS_FILTER = 'status'
export const CHANNELS_FILTER = 'notificationMethods'
export const SOURCE_FILTER = 'source'
export const CONTACT_TYPE_FILTER = 'badContact'
export const ZIP_CODE_FILTER = 'zipCode'

export const TYPE_ALL = 'ALL'
export const TYPE_SELECTED = 'SELECTED'
export const TYPE_STATUS = 'STATUS'

export const subscriberStatus = {
  [STATUS_ADDED]: {
    id: STATUS_ADDED,
    label: 'subscriber.status.added',
    type: AVAILABLE,
  },
  [STATUS_INVITED]: {
    id: STATUS_INVITED,
    label: 'subscriber.status.invited',
    type: ACCENT,
  },
  [STATUS_PENDING]: {
    id: STATUS_PENDING,
    label: 'subscriber.status.pending',
    type: DISTRESS,
  },
  [STATUS_REJECTED_BY_ADMIN]: {
    id: STATUS_REJECTED_BY_ADMIN,
    label: 'subscriber.status.rejected.by.admin',
    type: ERROR,
  },
  [STATUS_REJECTED_BY_APP_USER]: {
    id: STATUS_REJECTED_BY_APP_USER,
    label: 'subscriber.status.rejected_byAppUser',
    type: ERROR,
  },
  [STATUS_SUBSCRIBED_ACCEPT_REQUEST]: {
    id: STATUS_SUBSCRIBED_ACCEPT_REQUEST,
    label: 'subscriber.status.subscribed',
    type: NORMAL,
  },
  [STATUS_SUBSCRIBED_ACCEPT_INVITATION]: {
    id: STATUS_SUBSCRIBED_ACCEPT_INVITATION,
    label: 'subscriber.status.subscribed',
    type: NORMAL,
  },
  [STATUS_SUBSCRIBED_PUBLIC_SUBSCRIBE]: {
    id: STATUS_SUBSCRIBED_PUBLIC_SUBSCRIBE,
    label: 'subscriber.status.subscribed',
    type: NORMAL,
  },
  [STATUS_UNVERIFIED]: {
    id: STATUS_UNVERIFIED,
    label: 'subscriber.status.unverified',
    type: UNAVAILABLE,
  },
  [STATUS_UNSUBSCRIBED_REMOVE_SUBSCRIPTION]: {
    id: STATUS_UNSUBSCRIBED_REMOVE_SUBSCRIPTION,
    label: 'subscriber.status.unverified',
    type: ERROR,
  },
  [STATUS_UNSUBSCRIBED_UNSUBSCRIBED]: {
    id: STATUS_UNSUBSCRIBED_UNSUBSCRIBED,
    label: 'subscriber.status.unsubscribed',
    type: ERROR,
  },
  [STATUS_UNSUBSCRIBED_UNSUBSCRIBED]: {
    id: STATUS_UNSUBSCRIBED_UNSUBSCRIBED,
    label: 'subscriber.status.unsubscribed',
    type: ERROR,
  },
  [STATUS_DECLINE_BY_USER]: {
    id: STATUS_DECLINE_BY_USER,
    label: 'subscriber.status.declineByUser',
    type: ERROR,
  },
}

export const filterStatus = [
  {
    id: 1,
    name: STATUS_ADDED,
    label: 'subscriber.status.added',
    value: STATUS_ADDED,
    count: 0,
  },
  {
    id: 2,
    name: STATUS_INVITED,
    label: 'subscriber.status.invited',
    value: STATUS_INVITED,
    count: 0,
  },
  {
    id: 3,
    name: STATUS_SUBSCRIBED_PUBLIC_SUBSCRIBE,
    label: 'subscriber.status.subscribed',
    value: `${STATUS_SUBSCRIBED_ACCEPT_REQUEST},${STATUS_SUBSCRIBED_ACCEPT_INVITATION},${STATUS_SUBSCRIBED_PUBLIC_SUBSCRIBE}`,
    count: 0,
  },
  {
    id: 4,
    name: STATUS_PENDING,
    label: 'subscriber.status.pending',
    value: STATUS_PENDING,
    count: 0,
  },
  {
    id: 5,
    name: STATUS_REJECTED_BY_ADMIN,
    label: 'subscriber.status.rejected.by.admin',
    value: STATUS_REJECTED_BY_ADMIN,
    count: 0,
  },
  {
    id: 6,
    name: STATUS_REJECTED_BY_APP_USER,
    label: 'subscriber.status.rejected_byAppUser',
    value: STATUS_REJECTED_BY_APP_USER,
    count: 0,
  },
  {
    id: 7,
    name: STATUS_UNVERIFIED,
    label: 'subscriber.status.unverified',
    value: STATUS_UNVERIFIED,
    count: 0,
  },
  {
    id: 8,
    name: STATUS_UNSUBSCRIBED_UNSUBSCRIBED,
    label: 'subscriber.status.unsubscribed',
    value: `${STATUS_UNSUBSCRIBED_REMOVE_SUBSCRIPTION},${STATUS_UNSUBSCRIBED_UNSUBSCRIBED}`,
    count: 0,
  },
  {
    id: 9,
    name: STATUS_DECLINE_BY_USER,
    label: 'subscriber.status.declineByUser',
    value: STATUS_DECLINE_BY_USER,
    count: 0,
  },
]

export const filterSource = (appName) => [
  {
    id: 1,
    name: SOURCE_APP,
    label: 'subscriber.filter.notification.method.app',
    valueLabel: { appName: appName },
    value: SOURCE_APP,
  },
  {
    id: 2,
    name: SOURCE_CSV,
    label: 'source.csvImport',
    value: SOURCE_CSV,
  },
  {
    id: 3,
    name: SOURCE_SIS,
    label: 'oneroster.Veracross',
    value: SOURCE_SIS,
  },
  {
    id: 4,
    name: SOURCE_ONE_BY_ONE,
    label: 'source.addOnebyOne',
    value: SOURCE_ONE_BY_ONE,
  },
  {
    id: 5,
    name: SOURCE_WIDGET,
    label: 'source.subscriberWidget',
    value: SOURCE_WIDGET,
  },
  {
    id: 6,
    name: SOURCE_ISO,
    label: 'source.iosApp',
    value: SOURCE_ISO,
  },
  {
    id: 7,
    name: SOURCE_ANDROID,
    label: 'source.androidApp',
    value: SOURCE_ANDROID,
  },
]

export const filterContactType = [
  {
    id: 1,
    name: CONTACT_TYPE_VALID_0,
    label: 'subscriber.filter.valid',
    value: `${CONTACT_TYPE_VALID_0},${CONTACT_TYPE_VALID_1}`,
  },
  {
    id: 2,
    name: CONTACT_TYPE_INVALID,
    label: 'subscriber.filter.invalid',
    value: CONTACT_TYPE_INVALID,
  },
]

export const headerCVS = (formatMessage) => [
  {
    label: formatMessage({ id: 'firstName.label' }),
    key: 'firstName',
  },
  {
    label: formatMessage({ id: 'lastName.label' }),
    key: 'lastName',
  },
  {
    label: formatMessage({ id: 'subscriber.csv.label.subscriberEmail' }),
    key: 'email',
  },
  {
    label: formatMessage({ id: 'subscriber.label.language' }),
    key: 'language',
  },
  {
    label: formatMessage({ id: 'subscriber.label.uniqueId' }),
    key: 'uniqueId',
  },
  {
    label: formatMessage({ id: 'phone.label' }),
    key: 'crmPrimaryPhone',
  },
  { label: formatMessage({ id: 'subscriber.label.groups' }), key: 'tags' },
  {
    label: formatMessage({ id: 'subscriber.label.dateOfBirth' }),
    key: 'birthday',
  },
  {
    label: formatMessage({ id: 'crm.form.firstName' }),
    key: 'crmFirstName',
  },
  {
    label: formatMessage({ id: 'crm.form.middleName' }),
    key: 'crmMiddleName',
  },
  { label: formatMessage({ id: 'lastName.label' }), key: 'crmLastName' },
  {
    label: formatMessage({ id: 'crm.form.phoneticFirstName' }),
    key: 'crmPhoneticFirstName',
  },
  {
    label: formatMessage({ id: 'crm.form.phoneticMiddleName' }),
    key: 'crmPhoneticMiddleName',
  },
  {
    label: formatMessage({ id: 'crm.form.phoneticLastName' }),
    key: 'crmPhoneticLastName',
  },
  { label: formatMessage({ id: 'crm.form.prefix' }), key: 'crmPrefix' },
  { label: formatMessage({ id: 'crm.form.suffix' }), key: 'crmSuffix' },
  {
    label: formatMessage({ id: 'crm.form.formalTitle' }),
    key: 'crmFormalTitle',
  },
  { label: formatMessage({ id: 'crm.form.nickname' }), key: 'crmNickname' },
  {
    label: formatMessage({ id: 'crm.form.dateOfBirth' }),
    key: 'crmBirthday',
  },
  {
    label: formatMessage({ id: 'crm.form.placeOfBirth' }),
    key: 'crmPlaceOfBirth',
  },
  { label: formatMessage({ id: 'crm.form.gender' }), key: 'crmGender' },
  {
    label: formatMessage({ id: 'crm.form.nationality' }),
    key: 'crmNationality',
  },
  {
    label: formatMessage({ id: 'subscriber.label.uniqueId' }),
    key: 'uniqueId',
  },
  {
    label: formatMessage({ id: 'crm.form.careCheckId' }),
    key: 'carecheckId',
  },
  {
    label: formatMessage({ id: 'crm.form.passportId' }),
    key: 'crmPassportId',
  },
  {
    label: formatMessage({ id: 'crm.form.passportCountryCode' }),
    key: 'crmPassportCountryCode',
  },
  {
    label: formatMessage({ id: 'crm.form.passportExpiresAt' }),
    key: 'crmPassportExpiresAt',
  },
  { label: formatMessage({ id: 'crm.form.email' }), key: 'crmEmail' },
  {
    label: formatMessage({ id: 'crm.form.secondaryEmail' }),
    key: 'crmSecondaryEmail',
  },
  {
    label: formatMessage({ id: 'crm.form.otherMobileNumber' }),
    key: 'crmMobilePhoneNumber',
  },
  {
    label: formatMessage({ id: 'crm.form.otherPhoneNumber' }),
    key: 'crmOtherPhoneNumber',
  },
  {
    label: formatMessage({ id: 'crm.form.officePhoneNumber' }),
    key: 'crmOfficePhoneNumber',
  },
  {
    label: formatMessage({ id: 'crm.form.homePhoneNumber' }),
    key: 'crmHomePhoneNumber',
  },
  {
    label: formatMessage({ id: 'crm.form.faxNumber' }),
    key: 'crmFaxPhoneNumber',
  },
  {
    label: formatMessage({ id: 'crm.form.physicalCountry' }),
    key: 'crmPhysicalCountry',
  },
  {
    label: formatMessage({ id: 'crm.form.physicalStreetAddress' }),
    key: 'crmPhysicalStreetAddress1',
  },
  {
    label: formatMessage({ id: 'crm.form.physicalStreetAddressLine2' }),
    key: 'crmPhysicalStreetAddress2',
  },
  {
    label: formatMessage({ id: 'crm.form.physicalCityName' }),
    key: 'crmPhysicalCityName',
  },
  {
    label: formatMessage({ id: 'crm.form.stateType.state' }),
    key: 'crmPhysicalState',
  },
  {
    label: formatMessage({ id: 'crm.form.physicalPostalCode' }),
    key: 'crmPhysicalPostalCode',
  },
  {
    label: formatMessage({ id: 'crm.form.mailingCountry' }),
    key: 'crmMailingCountry',
  },
  {
    label: formatMessage({ id: 'crm.form.mailingStreetAddress' }),
    key: 'crmMailingStreetAddress1',
  },
  {
    label: formatMessage({ id: 'crm.form.mailingStreetAddressLine2' }),
    key: 'crmMailingStreetAddress2',
  },
  {
    label: formatMessage({ id: 'crm.form.mailingCityName' }),
    key: 'crmMailingCityName',
  },
  {
    label: formatMessage({ id: 'crm.form.mailingPostalCode' }),
    key: 'crmMailingPostalCode',
  },
  {
    label: formatMessage({ id: 'crm.form.stateType.state' }),
    key: 'crmMailingState',
  },
  {
    label: formatMessage({ id: 'crm.form.companyName' }),
    key: 'crmCompanyName',
  },
  { label: formatMessage({ id: 'crm.form.jobTitle' }), key: 'crmJobTitle' },
  {
    label: formatMessage({ id: 'crm.form.jobDepartment' }),
    key: 'crmJobDepartment',
  },
  {
    label: formatMessage({ id: 'crm.form.facebookProfile' }),
    key: 'crmFacebookProfile',
  },
  {
    label: formatMessage({ id: 'crm.form.twitterProfile' }),
    key: 'crmTwitterProfile',
  },
  {
    label: formatMessage({ id: 'crm.form.linkedinProfile' }),
    key: 'crmLinkedinProfile',
  },
  {
    label: formatMessage({ id: 'crm.form.lineProfile' }),
    key: 'crmLineProfile',
  },
]

export const SubscriberMenuAction = {
  DELETE: 'DELETE',
  APPROVE: 'APPROVE',
  INVITE: 'INVITE',
  REINVITE: 'REINVITE',
  REJECT: 'REJECT',
  MARK_CORRECT: 'MARK_CORRECT',
}

export const ACTION_SOURCE_ROW = 'row'
export const ACTION_SOURCE_CHECKBOX = 'checkbox'

export const TOGGLE_CREATE_DIALOG = 'TOGGLE_CREATE_DIALOG'
export const UPDATE_DATA = 'UPDATE_DATA'
export const SUBSCRIBERS_REQUEST = 'subscribers_request'
export const SUBSCRIBERS_REQUEST_SUCCESS = 'subscribers_request_success'

export const DELETE_SUBSCRIBERS_REQUEST = 'delete_subscribers_request'
export const EDIT_SUBSCRIBERS_REQUEST = 'edit_subscribers_request'
export const ADD_SUBSCRIBER_REQUEST = 'ADD_SUBSCRIBER_REQUEST'
export const GET_SUBSCRIBER_REQUEST = 'GET_SUBSCRIBER_REQUEST'
export const GET_SUBSCRIBERS_EXPORT_DATA = 'GET_SUBSCRIBERS_EXPORT_DATA'
export const APPROVE_SUBSCRIBER = 'APPROVE_SUBSCRIBER'
export const MARK_AS_CORRECT_REQUEST = 'mark_as_correct_request'

export const SET_GROUPS = 'SET_GROUPS'
export const SET_FORM_STATE = 'SET_FORM_STATE'
export const SET_FORM_EMAIL_PHONE_STATE = 'SET_FORM_EMAIL_PHONE_STATE'
export const SEARCH_REQUEST = 'SEARCH_request'
export const SUBSCRIBERS_COUNT_FOR_STATUSES = 'SUBSCRIBERS_COUNT_FOR_STATUSES'

export const LAST_INVITATION_STATUS_PENDING = 2

/* Import Subscriber */
export const LIMIT_CSV_IMPORT = 3001 // limit 3000 and 1 is header
export const STEP_PROGRESS_ONE = 1
export const STEP_PROGRESS_TWO = 2
export const STEP_PROGRESS_THREE = 3
export const REMOVE_CSV_FILE = 'REMOVE_CSV_FILE'
export const VIEW_VALID_CSV_FORMAT = 'isOpenDialogViewValidCSVFormat'
export const WHAT_IS_CSV_FILE = 'isOpenDialogWhatIsCSVFile'
export const MORE_IMPORT_HELP = 'isOpenDialogMoreImportHelp'
export const BACK_TO_IMPORT_PAGE = 'isOpenDialogBackToImportPage'
export const CSV_FILE_PATH = '/assets/files/subscriber.csv'
export const CSV_FILE_PATH_WITH_AUTOMATED_CALL =
  '/assets/file_automated_call/subscriber.csv'
export const CSV_FILE_CARECHECK_PATH = '/assets/files_carechek/subscriber.csv'
export const CSV_NEW_SAMPLE_FILE_PATH =
  '/assets/files/CSV_Import_Audiences_Template-Basic_Import.csv'
export const PREVIEW_ITEMS_LIMIT = 10
export const STATUS_IS_IMPORTED = 'isImported'
export const STATUS_IS_IMPORTED_NOTFULLY = 'isImportedNotFully'
export const STATUS_IS_FAILED = 'isFailed'
export const STATUS_IS_EMPTY = 'statusIsEmpty'
export const MAX_CSV_SIZE = 1 // MB
export const STEP_ONE = 1 // Check CSV Validation
export const STEP_TWO = 2 // Import CSV
export const CHECK_CSV_VALIDATION = 'CHECK_CSV_VALIDATION'
export const IMPORT_CSV = 'IMPORT_CSV'
export const CHECK_IMPORT_PROCESS = 'CHECK_IMPORT_PROCESS'
export const IMPORT_TYPE_CSV = 'csv'
export const IMPORT_TYPE_GOOGLE = 'google'
export const GOOGLE_LOGIN = 'get_google_login'
export const GET_GOOGLE_CONTACTS = 'get_google_contacts'
export const IMPORT_GOOGLE_CONTACTS = 'import_google_contacts'
export const OPTION_GOOGLE_LOGIN = 'googleLogin'
export const SUBSCRIBER_NOT_PASS_PERMISSION = 'notPassPermission'
export const SUBSCRIBER_PASS_PERMISSION = 'passPermission'
export const TYPE_GROUP = 'group'
export const TYPE_SUBGROUP = 'subGroup'
export const TYPE_SUBSCRIBERS = 'subscribers'
export const IMPORT_CSV_LIMIT = 3000
export const CRM_LIMIT = 3000

export const PARAMS_BAD_CONTACT = 'bad_contact'
export const BAD_CONTACT = 2

export const IMPORT_CSV_TAB = 'IMPORT_CSV'
export const IMPORT_EXTERNAL_SOURCE_TAB = 'IMPORT_EXTERNAL_SOURCE'
export const ADD_ONE_BY_ONE_TAB = 'ADD_ONE_BY_ONE'

export const CATEGORY_PLACE_FOR_IMPORT_SCHOOL = 'Education'

export const VIA_APP = 0
export const VIA_PLACE = 1
export const VIA_ONE_ROSTER = 2

export const MULTI_ACTION_PANEL = {
  SELECT_EXISTING: 'selectExistingGroup',
  CREATE_NEW: 'createGroup',
}

export const MULTI_ACTION_LOADING = {
  CREATING_GROUP: 'creatingGroup',
  ASSIGNING_GROUP: 'assigningGroup',
}
